import { render, staticRenderFns } from "./JoinAgent.vue?vue&type=template&id=74521ee0&scoped=true"
import script from "./JoinAgent.vue?vue&type=script&lang=js"
export * from "./JoinAgent.vue?vue&type=script&lang=js"
import style0 from "./JoinAgent.vue?vue&type=style&index=0&id=74521ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74521ee0",
  null
  
)

export default component.exports